<template>
  <app-notification
    :active-notification="activeNotification"
    :main-text="stockMessage"
    :additional-text="additionalText"
    has-close-button
    class="stock-notification"
    v-on="$listeners"
  >
    <template #additional-content>
      <div
        v-if="hasProductSizeStockMessage"
        class="stock-notification__additional-content additional-content"
      >
        <p class="additional-content__message">{{ additionalContentMessage }}</p>
        <button class="additional-content__action-button" @click="$emit('submit-option-change')">
          {{ $t('cart.volumeIsOutOfStockAdd') }}
        </button>
      </div>
    </template>
  </app-notification>
</template>

<script>
import AppNotification from '@/components/common/AppNotification.vue';

import { formatProductSize } from '@/utils/common';

import { getProductPackSize } from '@/models/core/ProductPack';
import { getSizeValue, getSizeUnits } from '@/models/core/values';

import { SIZE_MEASUREMENT_UNIT_KEY } from '@/constants/treatment';
import {
  STOCK_NOTIFICATION_MESSAGE,
  AVAILABILITY_NOTIFICATION_MESSAGE
} from '@/constants/notifications';

export default {
  name: 'StockNotification',
  components: { AppNotification },
  props: {
    activeNotification: {
      type: Boolean,
      default: false
    },
    productStockQuantity: {
      type: Number,
      default: 0
    },
    notificationType: {
      type: String,
      required: true
    },
    hasProductSizeStockMessage: {
      type: Boolean,
      default: false
    },
    availableProductOption: {
      type: Object,
      default: () => ({})
    },
    locale: {
      type: String,
      required: true
    }
  },
  computed: {
    availableProductSize() {
      return getProductPackSize(this.availableProductOption);
    },
    stockMessage() {
      const message =
        this.hasProductSizeStockMessage && this.productStockQuantity
          ? AVAILABILITY_NOTIFICATION_MESSAGE[this.notificationType]
          : STOCK_NOTIFICATION_MESSAGE[this.notificationType];

      return this.$t(message, [this.productStockQuantity]);
    },
    additionalText() {
      return this.hasProductSizeStockMessage ? '' : this.$t('cart.sorryForInconvenienceMessage');
    },
    additionalContentMessage() {
      const value = getSizeValue(this.availableProductSize);
      const units = getSizeUnits(this.availableProductSize);
      const unitsTranslated = this.$t(SIZE_MEASUREMENT_UNIT_KEY[units]);

      const productSize = formatProductSize({ value, units: unitsTranslated }, this.locale);

      return this.$t('cart.volumeIsOutOfStockQuestion', [productSize]);
    }
  }
};
</script>

<style lang="scss" scoped>
.additional-content {
  display: flex;

  &__message {
    margin-right: 5px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.4px;
    color: var(--u-color-grey-500);
  }

  &__action-button {
    color: var(--u-color-grey-900);
    background-color: transparent;
    text-decoration: underline;
    border: none;
    cursor: pointer;
  }
}
</style>
